import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";

const MusicController = () => {
    const fileInputRef = useRef(null);
    const [getData, setGetData] = useState([

        // title: "",
        // artist_id: "",
        // genre_id: "",
        // comment: "",



    ]);
    const [artists, setArtists] = useState([]);
    const [selectedArtist, setSelectedArtist] = useState("");
    const [newArtist, setNewArtist] = useState("");
    const [genres, setGenres] = useState([]);
    const [selectedGenre, setSelectedGenre] = useState("");
    const [newGenre, setNewGenre] = useState("");
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});
    const [addData, setAddData] = useState({

        title: "",
        artist_id: "",
        genre_id: "",
        comment: "",
        audio: "",
    })



    //データの取得メソッド
    useEffect(() => {
        const fetchData = async () => {
            try {
                //artistデータの取得
                const artistResponse = await axios.get("http://127.0.0.1:8000/api/artists");
                setArtists(artistResponse.data);

                //genreデータの取得
                const genreResponse = await axios.get("http://127.0.0.1:8000/api/genres/");
                setGenres(genreResponse.data);

                //曲データの取得
                const response = await axios.get("http://127.0.0.1:8000/api/songs/");
                setGetData(response.data);
            } catch (error) {
                console.error('データ取得に失敗しました。', error);
            }
        }
        fetchData();
        console.log("getData", getData);
    }, [refreshFlag]);

    //データの追加メソッド

    const addNewSong = async () => {
        const formData = new FormData();
        console.log("data:", addData);
        for (const key in addData) {
            formData.append(key, addData[key]);
        }

        try {
            const response = await axios.post('http://127.0.0.1:8000/api/songs', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Accept": "application/json",
                }
            });

            if (response.status === 201) {
                alert("送信に成功しました。");

                setRefreshFlag(!refreshFlag);
                setAddData({

                    title: "",
                    artist_id: "",
                    genre_id: "",
                    comment: "",
                    audio: "",
                });
                setSelectedArtist("");
                setSelectedGenre("");
                setErrorMessage({});
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }

            } else {
                alert('送信に失敗しました。');
            }


        } catch (error) {
            console.error("エラー詳細:", error);

            if (error.response) {
                console.log("ステータスコード:", error.response.status);
                console.log("レスポンスデータ:", error.response.data.errors);
                console.log("型チェック:", typeof error.response.data.errors); // 'object' であるべき
                console.log("内容:", error.response.data.errors);
                if (error.response){
                    const errors = error.response.data.errors || {};//!一度定数に格納、オブジェクト形式を指定
                    setErrorMessage(errors);
                    console.log("エラーをセット",errors);
                }
            } else if (error.request) {
                console.error("リクエストエラー（サーバーに到達しませんでした）:", error.request);
            } else {
                console.error("その他のエラー:", error.message);
            }

        }
    }


    useEffect(() => {
        console.log("更新されたエラーメッセージ:", errorMessage);
    }, [errorMessage]);

    // console.error("追加に失敗しました。", error);
    // if (error.response && error.response.data.errors) {
    //     setErrorMessage(error.response.data.errors); // エラーメッセージをセット
    // } else {
    //     console.error("errorMessage", error);
    // }


    // データの削除
    const deleteData = async (id) => {
        try {
            const response = await axios.delete(`http://127.0.0.1:8000/api/songs/${id}`);
            if (response.status === 204) {
                alert("削除に成功しました。");
                setRefreshFlag(!refreshFlag);

            } else {
                alert("削除に失敗しました。");
            }
        } catch (error) {
            console.error('削除エラー', error);
        }
    }


    //新規アーティストの追加
    const addNewArtist = async () => {
        if (!newArtist.trim()) {
            alert('artist名を入力してください');
            return;
        }
        try {
            const response = await axios.post("http://127.0.0.1:8000/api/artists", {
                name: newArtist,
            })

            setArtists((prev) => [...prev, response.data]);
            setNewArtist("");
            setRefreshFlag(!refreshFlag);

        } catch (error) {
            console.error('アーチスト情報の取得に失敗しました。', error);
            alert('アーチスト情報の取得に失敗しました。');
        }

    }
    //新規ジャンルの追加
    const addNewGenre = async () => {
        if (!newGenre.trim()) {
            alert('ジャンル名を入力してください');
            return;
        }
        try {
            const response = await axios.post("http://127.0.0.1:8000/api/genres", {
                name: newGenre,
            })

            setGenres((prev) => [...prev, response.data]);
            setNewGenre("");
        } catch (error) {
            console.error('ジャンル情報の取得に失敗しました。', error);
            alert('ジャンル情報の取得に失敗しました。');
        }



    }

    //

    //genre選択ハンドラ
    const handleGenreChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedGenre(selectedValue);
        setAddData((prev) => ({ ...prev, genre_id: selectedValue }))
    };

    //artist選択ハンドラ
    const handleArtistChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedArtist(selectedValue);
        setAddData((prev) => ({ ...prev, artist_id: selectedValue }))
    };

    const handleAdd = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setAddData((prev) => ({ ...prev, [name]: value }))
        console.log("adddata", addData);

    }

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setAddData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    }



    return (
        <div>
            <section>
                {/* エラーメッセージの表示部分 */}
                {/* {Object.entries(errorMessage).map(([field, messages]) => (
                    <div key={field} style={{ color: "red", marginBottom: "10px" }}>
                        {messages.map((message, index) => (
                            <p key={index}>{message}</p>
                        ))}
                    </div>
                ))} */}
                {/* {errorMessage.title}
                {errorMessage.artist_id} */}
                {errorMessage.title && <p>{errorMessage.title}</p>}

            </section>
            <section>

                <form onSubmit={(e) => {
                    e.preventDefault();
                    addNewSong();
                }}>
                    <table className="music-table-wrapper">
                        <tbody>
                            <tr className="music-tr-element">
                                <td className="music-td-content left">
                                    タイトル
                                </td>
                                <td className="music-td-content right">
                                    <input value={addData.title} onChange={handleAdd} name="title" />
                                    {errorMessage.title && <p>{errorMessage.title}</p>}

                                </td>
                            </tr>
                            <tr className="music-tr-element">
                                <td className="music-td-content left">
                                    アーチスト
                                </td>
                                <td className="music-td-content right">
                                    <select
                                        id="artist"
                                        name="artist_id"
                                        value={selectedArtist}
                                        onChange={handleArtistChange}>
                                        <option value="">アーティストを選択</option>
                                        {artists.map((artist) => (


                                            <option
                                                key={artist.id}
                                                value={artist.id}>

                                                {artist.name}
                                            </option>




                                        ))}
                                    </select>
                                    <div>

                                        <input type="text" name="artist" placeholder="新しいアーティスト" value={newArtist} onChange={(e) => setNewArtist(e.target.value)} />
                                        <button type="button" name="artist" onClick={addNewArtist}>
                                            アーティストを追加する
                                        </button>
                                        {errorMessage.artist_id && <p>{errorMessage.artist_id}</p>}

                                    </div>
                                </td>
                            </tr>
                        </tbody>



                        <tr className="music-tr-element">
                            <td className="music-td-content left">
                                ジャンル
                            </td>
                            <td className="music-td-content right">
                                <select
                                    id="genre"
                                    name="ganre"
                                    value={selectedGenre}
                                    onChange={handleGenreChange}>
                                    <option value="">ジャンルを選択</option>
                                    {genres.map((genre) => (


                                        <option
                                            name="g1"
                                            key={genre.id}
                                            value={genre.id}>

                                            {genre.name}
                                        </option>

                                    ))}
                                </select>
                                <div>

                                    <input type="text" name="genre" placeholder="新しいジャンル" value={newGenre} onChange={(e) => setNewGenre(e.target.value)} />
                                    <button type="button" name="genre" onClick={addNewGenre}>
                                        ジャンルを追加する
                                    </button>
                                    {errorMessage.genre_id && <p>{errorMessage.genre_id}</p>}

                                </div>
                            </td>
                        </tr>
                        <tr className="music-tr-element">
                            <td className="music-td-content left">
                                コメント
                            </td>
                            <td className="music-td-content right">
                                <textarea value={addData.comment} onChange={handleAdd} name="comment" />
                            </td>
                        </tr>
                        <tr className="music-tr-element">
                            <td className="music-td-content left">
                                追加ファイル
                            </td>
                            <td className="music-td-content right">
                                <input ref={fileInputRef} name="audio" type="file" onChange={handleFileChange} />
                                {errorMessage.audio && <p>{errorMessage.audio}</p>}

                            </td>
                        </tr>
                    </table>
                    <button type="submit">送信</button>
                </form>
            </section>


            {/* -------------------------------- */}

            <section>

                <div style={styles.container}>
                    <h1 style={styles.title}>Song List</h1>
                    <div style={styles.songList}>
                        {getData.map((song) => (
                            <div key={song.id} style={styles.songCard}>
                                <button onClick={() => { deleteData(song.id) }}>delete</button>
                                <h2 style={styles.songTitle}>{song.title}</h2>
                                <p style={styles.detail}>
                                    <strong>Artist:</strong> {song.artist?.name || "Unknown"}
                                </p>
                                <p style={styles.detail}>
                                    <strong>Genre:</strong> {song.genre?.name || "Unknown"}
                                </p>
                                <p style={styles.detail}>
                                    <strong>Comment:</strong> {song.comment || "No comment"}
                                </p>
                                <audio controls style={styles.audioPlayer}>
                                    <source src={song.audio_url} type="audio/mpeg" />
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                        ))}
                    </div>
                </div>

            </section>

        </div>
    )

}

const styles = {
    container: {
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "'Arial', sans-serif",
    },
    title: {
        textAlign: "center",
        marginBottom: "20px",
        color: "#333",
    },
    songList: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
    songCard: {
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "15px",
        backgroundColor: "#f9f9f9",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    songTitle: {
        fontSize: "1.5rem",
        marginBottom: "10px",
        color: "#555",
    },
    detail: {
        margin: "5px 0",
        color: "#666",
    },
    audioPlayer: {
        marginTop: "10px",
        width: "100%",
    },
};








export default MusicController;